"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductBuilderCategoryTabPanel = void 0;
const React = require("react");
const react_1 = require("react");
const Circle_1 = require("@mui/icons-material/Circle");
const material_1 = require("@mui/material");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "ProductBuilderCategoryTabPanel");
const ProductBuilderCategoryTabPanel = ({ salesOrderItemBuilt, scrollToCategory }) => {
    const { productBlueprint: { requiredCategoriesMap, categories } } = salesOrderItemBuilt;
    const [value, setValue] = (0, react_1.useState)(null);
    const handleChange = (_event, category) => {
        setValue(category);
        setTimeout(() => scrollToCategory(category), 400);
    };
    (0, react_1.useEffect)(() => {
        if (!salesOrderItemBuilt) {
            return;
        }
        if (value) {
            return;
        }
        setValue(categories[0].name);
    }, [salesOrderItemBuilt]);
    return (React.createElement("div", { className: css("") },
        React.createElement(material_1.Tabs, { value: value, onChange: handleChange, variant: "scrollable", scrollButtons: true, allowScrollButtonsMobile: true }, categories.map((category, index) => {
            const isRequired = requiredCategoriesMap.get(category.name);
            return (React.createElement(material_1.Tab, { label: category.label, icon: isRequired && React.createElement(Circle_1.default, { color: "error", fontSize: "inherit" }), iconPosition: "start", key: index, value: category.name }));
        }))));
};
exports.ProductBuilderCategoryTabPanel = ProductBuilderCategoryTabPanel;
//# sourceMappingURL=index.js.map